import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import {
    IContextService, DomainContext,
    PershingTranslationService, IAppDataStore
} from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-holdings-aggregate',
    templateUrl: './holdings-aggregate.component.html'
})
export class DojoHoldingsAggregateComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    managedAccount: any;
    subs: Subscription;
    acctRef: any;
    appSettings: any;
    assetType: string = 'all';
    realTimeActive: boolean = false;
    isAdaTheme: boolean = false;
    isMobileTheme: boolean = false;
    isAgreementsigned: boolean = false;
    title: string;
    response: any;
    isTRP: boolean = false;
    isTradelink: boolean = false;
    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private route: ActivatedRoute,
        private router: Router,
        private nxiRestService: NxiRestService,
        private nxiWidgetParamsService: NxiWidgetParamsService,
        private appDataStore: IAppDataStore,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.appSettings = appSettings;
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
            this.title = 'dojo-holdings-aggregate';
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobileTheme = true;
        }
        if (appSettings.ibdConfigMap.IBD && appSettings.ibdConfigMap.IBD === '30A') {
            this.isTRP = true;
        }
        if (appSettings.ibdConfigMap.community && appSettings.ibdConfigMap.community === 'tradelink') {
            this.isTradelink = true;
        }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.route.queryParams.subscribe(params => {
                if (!!params && (!!params.rt || !!params.assetType || !!params.assetQueryBy)) {
                    if (params.rt) {
                        this.realTimeActive = params.rt;
                    }
                    if (params.assetType) {
                        this.assetType = params.assetType;
                    }
                } else {
                    // Routing back to holdings page to populate params for holdings-details page. Holdings-details page is only there for adaptive.
                    if (this.router.url.includes('holdings-details')) {
                        document.dispatchEvent(new CustomEvent('portal.gotoview', {
                            detail: {
                                'gotoPage': '/nxi/portfolio/holdings'
                            }
                        }));
                    }
                }
            });
            this.getHoldingsAggregateGrid();
        });
    }

    ngOnDestroy(): void {
        console.log('In DojoHoldingsAggregateComponent destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyHoldingsAggregate();
        }
    }
    renderDojoWidget(holdingsAggregateDojoParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            holdingsAggregateDojoParams.nxiRestBaseUrl = this.nxiRestService.serviceUrl;
            dojoApp.renderHoldingsAggregate(this.inputValue, holdingsAggregateDojoParams);
        }
    }

    getHoldingsAggregateGrid() {
        if (this.acctRef) {
            if (sessionStorage.getItem('realTimeActive') && 'true' === sessionStorage.getItem('realTimeActive')) {
                this.realTimeActive = true;
            } else {
                this.realTimeActive = false;
            }
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'holdingsAggregate?rt=' + this.realTimeActive).subscribe(
                resp => {
                    if (resp.response) {
                        this.response = resp.response;
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = this.appSettings.ibdConfigMap.modApiUrl;
                        this.managedAccount = resp.response.managedAccount;
                        resp.response.assetType = this.assetType;
                        this.isAgreementsigned = resp.response.hasUserSignedExchAgmt;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }

    gotoRoute(page: string): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': page
            }
        }));
    }
}
